import { render, staticRenderFns } from "./SaleTable.vue?vue&type=template&id=494798e0&scoped=true"
import script from "./SaleTable.vue?vue&type=script&lang=js"
export * from "./SaleTable.vue?vue&type=script&lang=js"
import style0 from "./SaleTable.vue?vue&type=style&index=0&id=494798e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494798e0",
  null
  
)

export default component.exports